import { render, staticRenderFns } from "./EscalaFolga.vue?vue&type=template&id=8fe877a2&"
import script from "./EscalaFolga.vue?vue&type=script&lang=js&"
export * from "./EscalaFolga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports